module.exports = {"previous":"Trước","next":"Tiếp"};